import React, { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { CustomTable } from "@components/custom-table/table";
import { resetDelete } from "@helpers/custom-delete/controller/delete-slice";
import { url } from "@constants/url-constants";
import { S3_BASE_URL } from "@constants/constants";
import { getMediumType } from "../../../helpers/helpers";
import DeleteModal from "@components/custom-table/DeleteModal";
import { resetError, resetState, resetSuccess } from "../controller/customer-feedback-slice";
import { getFeedbackLogs } from "../services/customer-feedback-services";
import { LOG_VIEW_ID } from "../../../helpers/permission/constant-permissions";
import { STORAGE_KEY } from "../../../constants/constants";
export const CustomerFeedback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customerFeedback = useSelector((state) => state.customerFeedback.customerFeedbacks);
    const pagination = useSelector((state) => state.customerFeedback.pagination);
    const isLoading = useSelector((state) => state.customerFeedback.loading);
    const responseMessage = useSelector((state) => state.customerFeedback.responseMessage);
    const successMessage = useSelector((state) => state.customerFeedback.successMessage);
    const deleteMessage = useSelector((state) => state.delete.successMessage);
    const currentPage = pagination?.current_page;
    const deleteUrl = url.banners;
    const [deleteModel, setDeleteModel] = useState(false);
    const [deleteData, setDeleteData] = useState({});
      const userData = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));
    
    useEffect(() => {
        if (responseMessage !== null) {
            dispatch(resetState());
        }
    }, [dispatch, responseMessage]);

    useEffect(() => {
        if (deleteMessage !== null) {
            toast.success(deleteMessage);

            dispatch(resetDelete());
        }
    }, [dispatch, deleteMessage]);

    useEffect(() => {
        if (successMessage !== null) {
            toast.success(successMessage);

            dispatch(resetSuccess());
        }
    }, [dispatch, successMessage]);

    const handleCreateBanner = () => {
        navigate(`/banner/add`);
        dispatch(resetError());
    };
    const handleDeleteBanner = ({ id, url, deleted_at }) => {
        setDeleteModel(true);
        setDeleteData({ id, url, deleted_at });
    };

    const handleEditState = ({ id, page }) => {
        navigate(`/banner/edit/${id}?current_page=${page}`);
        dispatch(resetError());
    };

    const columns = useMemo(
        () => {
            const cols = [
                // {
                //     header: "Sorting ",
                //     accessorKey: "sorting",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
                {
                    header: "User Name",
                    accessorKey: "",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return cellProps.row.original.user_details
                            ?.full_name ?? "-"
                    },
                },
                {
                    header: "Mobile",
                    accessorKey: "",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return cellProps.row.original.user_details
                            ?.mobile
                    },
                },
                {
                    header: "Email",
                    accessorKey: "",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return cellProps.row.original.user_details
                            ?.email ?? "-"
                    },
                },
                {
                    header: "Media",
                    accessorKey: "media",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return cellProps.row.original.media_id
                            ? getMediumType(cellProps.row.original.media?.type) +
                            "-" +
                            cellProps.row.original.media?.title //TODO
                            : "Posts-" + cellProps.row.original.post.title;
                    },
                },
                {
                    header: "Episode",
                    accessorKey: "episode",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {

                        return cellProps.row.original.content_unit_id != null ? `Episode - ${cellProps.row.original.content_unit?.name}` : cellProps.row.original.post_id != null ? "Post" : "Trailer"
                    },
                },
                {
                    header: "Feedback",
                    accessorKey: "description",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
            ]
            return cols
        },
        [currentPage, deleteUrl]
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModel}
                onDeleteClick={handleDeleteBanner}
                onCloseClick={() => setDeleteModel(false)}
                data={deleteData}
            />
            <div className="page-content">
                <ToastContainer autoClose={2000} />
                <div className="container-fluid">
                    {
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="">
                                        <div className="d-flex align-items-center text-start">
                                            <h5 className="mb-0 card-title flex-grow-1">
                                                Feedback Logs
                                            </h5>
                                        </div>
                                    </CardBody>
                                    <CardBody>
                                        <CustomTable
                                            loading={isLoading}
                                            columns={columns}
                                            data={customerFeedback || []}
                                            isCustomPageSize={true}
                                            isGlobalFilter={true}
                                            isJobListGlobalFilter={true}
                                            isPagination={true}
                                            isAddButton={true}
                                            isAddPermission={userData?.permission_ids?.includes(LOG_VIEW_ID)}
                                            page={currentPage}
                                            isEpisode={true}
                                            paginationCount={pagination?.total_count}
                                            handleUserClick={handleCreateBanner}
                                            handleList={getFeedbackLogs}
                                            paginationLimit={pagination}
                                            buttonClass="btn btn-success"
                                            buttonName="Add"
                                            theadClass="thead-light"
                                            SearchPlaceholder="Search for ..."
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                            pagination="pagination"
                                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};
